import { render, staticRenderFns } from "./addnew.vue?vue&type=template&id=cb43e7fc&scoped=true"
import script from "./addnew.vue?vue&type=script&lang=js"
export * from "./addnew.vue?vue&type=script&lang=js"
import style0 from "./addnew.vue?vue&type=style&index=0&id=cb43e7fc&prod&lang=css"
import style1 from "./addnew.vue?vue&type=style&index=1&id=cb43e7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb43e7fc",
  null
  
)

export default component.exports